/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_Case_ValueInputs */

const en_cases_col_case_value = /** @type {(inputs: Cases_Col_Case_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case value`)
};

const pt_br2_cases_col_case_value = /** @type {(inputs: Cases_Col_Case_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor caso`)
};

/**
* | output |
* | --- |
* | "Case value" |
*
* @param {Cases_Col_Case_ValueInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_case_value = /** @type {((inputs?: Cases_Col_Case_ValueInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_Case_ValueInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_case_value(inputs)
	return pt_br2_cases_col_case_value(inputs)
});